module.exports = __webpack_public_path__ + "img/no-resutls.9dacd5e7.svg";